import Vue from 'vue'

import mixFileRequestManage from '@/code-lab/component/file-management/mixins/mix-file-request-manage.js'
import toolMix from '@/code-lab/component/file-management/mixins/tool-mix.js'
import { mapState, mapActions } from 'vuex';
export default {
    mixins: [ mixFileRequestManage, toolMix ],
    data: () => ({ importData: null, importElem: null }),
    computed: {
        ...mapState('notifySystem', { currentWhere: 'currentWhereOfFolderList', notifyInstance: 'notifyInstance' })
    },
    methods: {
        ...mapActions("notifySystem", { newAct$: 'new' }),
        creteIputElm ({ accept }) {
            let input$ = document.createElement('input')
            input$.setAttribute('type', 'file')
            input$.setAttribute('accept', accept)
            return input$
        },
        triggerFileEvent ({ requestId: notifyId }) {
            const elm = this.creteIputElm({ accept: ['.mbkx'] })
            console.log(notifyId, elm)
            document.body.appendChild(elm)
            elm.click()
            elm.addEventListener('change', et => {
                console.log("change", et)
                this.handleFileData(et, notifyId)
            })
            document.body.removeChild(elm)
            return notifyId
        },
        handleFileData (file, notifyId) {
            
            if (!file) return
            const reader = new FileReader()
            reader.readAsArrayBuffer(file)
            reader.onload = async e => {
                const rawData = e.target.result
                await this.sendBinary({ file, rawData }, notifyId)
            }
        },
        async import_project (callBack, resMsg) {
            const ctx = this.b$
            return await ctx
            .send('tool', { "cmd": "import_project", data: { ...resMsg } }, callBack)
            .then(async ctx => {
                const { nextTo } = ctx
                return nextTo
            })
        },
        async sendBinary ({ file, rawData }, notifyId) {
            const { clientId } = this.b$.tool.store
            const sId = this.importData.data.sId
            await this.b$.sendBinary('tool', {
                sId,
                to: "server",
                from: clientId,
                size: file.size,
                sourceName: file.name,
                destinationName: file.name
            }, rawData, res => {
                if (res.eventName === "ftp_send_progress") {
                    let { current, size } = res.data
                    current === 0 && this.open({ currentWhere: JSON.parse(JSON.stringify(this.currentWhere)), notifyId$: notifyId, svg: '#t-code-notify-manage-loading', href: "static/svg/pop/loading.svg", content: Vue.prototype.$t("code-lab/component/mixins/import-mix.js_0"), title: Vue.prototype.$t("code-lab/component/mixins/import-mix.js_1") })
                    this.$store.commit("notifySystem/update", { id: notifyId, notify: {
                        progress: Math.trunc(current / size * 100)
                    } })
                } else if (res.eventName === "ftp_send_end") {
                    console.log(100)
                }
            }).catch(err => {
                err === 0 && this.$message.error(Vue.prototype.$t( "code-lab/component/mixins/import-mix.js_2" ));
                console.error(err)
            })
        },
        

        async execution () {
            return new Promise(async (resolve, reject) => {
                const requestId = this.util$.getRandomId$('import_project')
                const handler = async result => {
                    const arr = ["done", "task_creating", "task_created", "task_finished", 'todo']
                    if (!arr.includes(result.data.state)) {
                        this.importFailed(requestId)
                        return reject()
                    }
                    if (result.data.state === 'task_finished') {
                        const index = this.notifyInstance.findIndex(f => f.id === requestId)
                        const { currentWhere } = this.notifyInstance[index]
                        const { _id, pathNam$ } = currentWhere, { name: importFileName, projectId } = result.data
                        const fn = response => {
                            if (response.status && Number(response.status.code) === 0) {
                                this.$store.commit("notifySystem/update",
                                    {   id: requestId,
                                        notify: { href: "static/svg/pop/successful.svg", svg: '#code-lab-import-successful-icon', progress: 100, title: Vue.prototype.$t("code-lab/component/mixins/import-mix.js_3"),
                                        content: `「${this.strSliceStarAndEndT(importFileName, 7, 4, '..')}」${ Vue.prototype.$t("code-lab/component/mixins/import-mix.js_4") } ${this.groupsFormatter(pathNam$)}`,
                                        hide: false
                                    }
                                })
                                if (currentWhere.path === this.currentWhere.path) {
                                    this.$store.commit("notifySystem/isUpdateData", true)
                                }
                                window.clearInterval(this.notifyInstance[index].timer)
                            }
                        }
                        this.move_project$ (fn, { folderId: _id, projectIds: [ projectId ], ...this.getRequestQuery(currentWhere) })
                    }
                    if (result.data.state !== 'todo') return
                    this.importData = result
                    
                    
                    return resolve(requestId)
                }
                await this.import_project(handler, { requestId })
                
            })
           
        },
        open ({ currentWhere, title, content, duration = 0, svg, href, notifyId$ }) {
            this.newAct$({ hide: false, id: notifyId$, progress: 0, content, title, href, svg, duration, currentWhere })
        },
        importFailed (requestId) {
            const index = this.notifyInstance.findIndex(f => f.id === requestId)
            this.$store.commit("notifySystem/update",
                { id: requestId, notify: { href: "static/svg/pop/filed.svg", svg: '#code-lab-import-failed-icon', progress: 100, title: Vue.prototype.$t("code-lab/component/mixins/import-mix.js_5"), content: `${ Vue.prototype.$t("code-lab/component/mixins/import-mix.js_6") }... ${ Vue.prototype.$t("code-lab/component/mixins/import-mix.js_7") }，${ Vue.prototype.$t("code-lab/component/mixins/import-mix.js_8") }！` }
            }),
            window.clearInterval(this.notifyInstance[index].timer)
        },
        groupsFormatter(strTarg) {
            const fn1 = this.formatStringSubstrT
            const arr = strTarg.split('/')
            const fn = (data, end = 4) => data.reduce((a, b) => [...a, ...[ b.length > end ? fn1(b, { s: 0, e: end }, '..') : b ]], [])
            const res = arr.length >= 3
            ? [...fn(arr.slice(0, 1)), '...', ...[fn1(arr[arr.length - 1], { s: 0, e: 3 }, '...')]]
            : arr.length > 1 ? fn(arr) : fn(arr, 8)
            return res.join('/')
        },
    },
}
